<div ngbTooltip="{{'buttons.errorJson' | translate}}" tooltipClass="animation-tooltip" placement="top" container="body"
    triggers="hover" (click)="open(content, $event)" class="greenEye">
    <div aria-label="details" [inlineSVG]="'assets/ico/visibility-green.svg'"></div>
</div>
<ng-template #content let-modal>
    <div class="modal-header light-blue">
        <div class="container-fluid">
            <div class="row modal-header-row">
                <div class="modal-icon icon fill-white" aria-label="logo" [inlineSVG]="'assets/ico/exclamation-triangle-regular-white.svg'">
                </div>
                <span class="modal-title" id="modal-basic-title">{{'order.errors.details' |
                    translate}}</span>
                <div class="modal-icon icon fill-white close-icon" (click)="close()" aria-label="close"
                    [inlineSVG]="'assets/ico/close-24px.svg'"></div>
            </div>
        </div>
    </div>
    <div class="modal-body">
        <div class="fullwidth">
            <div class="container-fluid">
                <div class="mb-1">{{'order.errors.updated' | translate}}: {{updated}}</div>
                <ngx-json-viewer [json]="jsonParsed" [expanded]="true"></ngx-json-viewer>
            </div>
        </div>
    </div>
    <div class="modal-footer p-0">
        <div class="container-fluid m-0 p-0">
            <span class="btn modal-btn save" (click)="close()">Ok</span>
        </div>
    </div>
</ng-template>